import { types } from "../types/types"

export const menuActive = (data) => {
    return {
        type: types.menuActive,
        payload: data
    }
}